import React from 'react'
import {
  SmallNavContainer,
  SmallLogoContainer,
  HamburgerMenuContainer,
  HamburgerMenuTopBar,
  HamburgerMenuMiddleBar,
  HamburgerMenuBottomBar,
  BaseHamburgerMenuItem,
  SmallAnchor,
  StyledNavPanel,
  LoggedInSmallNavItemsTopContainer,
  SmallNavItemsBottomContainer,
} from 'components/Header/Styled'

const RenderNavLinks = ({ navigationItems }) => {
  if (!navigationItems || navigationItems.length === 0) {
    return null
  }

  return (
    navigationItems &&
    navigationItems.length > 0 &&
    navigationItems.map((item, id) => (
      <BaseHamburgerMenuItem href={item.link} key={id}>
        {' '}
        {item.title}
      </BaseHamburgerMenuItem>
    ))
  )
}

const StyledNavDropdownPanel = ({ show, loggedInNavigationItems, profileNavigationItems }) => (
  <StyledNavPanel show={show}>
    <LoggedInSmallNavItemsTopContainer>
      <RenderNavLinks navigationItems={loggedInNavigationItems} />
    </LoggedInSmallNavItemsTopContainer>
    <SmallNavItemsBottomContainer>
      <RenderNavLinks navigationItems={profileNavigationItems} />
    </SmallNavItemsBottomContainer>
  </StyledNavPanel>
)

export const LoggedInSmallHeader = ({
  altTag,
  logo,
  loggedInNavigationItems,
  handleNavClick,
  show,
  profileNavigationItems,
}) => (
  <>
    <SmallNavContainer>
      <SmallLogoContainer>
        <SmallAnchor href='/'>
          <img alt={altTag} src={logo} height='40px' />
        </SmallAnchor>
        <HamburgerMenuContainer onClick={handleNavClick}>
          <HamburgerMenuTopBar changed={show} />
          <HamburgerMenuMiddleBar changed={show} />
          <HamburgerMenuBottomBar changed={show} />
        </HamburgerMenuContainer>
      </SmallLogoContainer>
    </SmallNavContainer>
    <StyledNavDropdownPanel
      show={show}
      loggedInNavigationItems={loggedInNavigationItems}
      profileNavigationItems={profileNavigationItems}
    />
  </>
)
